import React, { useEffect, useState } from 'react';
import { mergeStyleSets, Modal, IconButton, getTheme } from '@fluentui/react';
import { observer, inject } from 'mobx-react';
import useScriptLoader from 'src/hooks/useScriptLoader'

const theme = getTheme();

const modalStyles = {
    root: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
};

const classNames = mergeStyleSets({
    content: {
        backgroundColor: 'white',
        padding: '3rem 1rem 1rem 1rem',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
        width: '90%',
        minHeight: '35%',
        position: 'relative',

        '*': {
            fontFamily: theme.fonts.medium.fontFamily
        }
    },

});

const closeButtonStyles = {
    root: {
        position: 'absolute',
        top: '12px',
        right: '12px',
        padding: '8px',
    }
};

const FORM_CONTAINER_ID = 'invite-form';
const HUBSPOT_SCRIPT_URL = 'https://js.hsforms.net/forms/embed/v2.js';

const loadHubspotForm = (referrer) => {
    window.hbspt?.forms.create({
        portalId: config.hubspot.portalId,
        formId: config.hubspot.formId,
        target: `#${FORM_CONTAINER_ID}`,
        onFormReady: function (form) {
            var referrerField = form.querySelector('input[name$="referrer"]');
            if (!referrerField) {
                console.log("Errow while rendering form");
                return;
            }
            referrerField.value = referrer;
        }
    });
};

const InviteForm = ({ isOpen, onDismiss, userStore }) => {

    const [isHubspotScriptLoaded, setHubspotScriptLoaded] = useState(false);
    const hubspotScriptLoader = useScriptLoader(HUBSPOT_SCRIPT_URL);

    useEffect(() => {
        if (!isOpen) { return; }

        const referrer = userStore.user.email;

        if (!isHubspotScriptLoaded) {
            hubspotScriptLoader(() => {
                setHubspotScriptLoaded(true);
                loadHubspotForm(referrer);
            });
        }
        else {
            loadHubspotForm(referrer);
        }
    }, [isOpen])

    return (
        <Modal
            isOpen={isOpen}
            onDismiss={onDismiss}
            isBlocking={true}
            styles={modalStyles}
            containerClassName={classNames.content}
        >
            <IconButton
                styles={closeButtonStyles}
                iconProps={{ iconName: 'Cancel' }}
                ariaLabel="Close modal"
                onClick={onDismiss}
            />
            <div id={FORM_CONTAINER_ID}>

            </div>
        </Modal>
    );
};


export default inject('userStore')(observer(InviteForm));